// ─────────────────────────────────────────────────────────────────────────────
// L'écran d'accueil d'un compte.
//
// Le portefeuille, ou à défaut le premier écran que ses modules ouvrent, dans
// l'ordre de la barre. Un compte limité à Entertainment (la démonstration
// d'ITV, 28 septembre 2026) atterrissait, une fois connecté, sur le refus du
// portefeuille : il fallait taper `/entertainment` à la main pour entrer.
//
// Un compte qui n'ouvre RIEN garde le portefeuille : son garde renvoie vers
// l'écran qui nomme la permission manquante, plutôt que vers une page vide.
// ─────────────────────────────────────────────────────────────────────────────
import { useSession } from '../composables/session';

const ACCUEILS: ReadonlyArray<{ module: string; route: string }> = [
  { module: 'portfolio', route: 'v4-portfolio' },
  { module: 'sentinel', route: 'v4-dossier-sentinel' },
  { module: 'discovery', route: 'v4-discovery' },
  { module: 'replica', route: 'v4-replica' },
  { module: 'radar', route: 'v4-radar' },
  { module: 'sonar', route: 'v4-sonar' },
  { module: 'polis-projection', route: 'v4-polis' },
  { module: 'polis', route: 'v4-polis' },
  { module: 'polis-annuaire', route: 'v4-polis-personnalites' },
  { module: 'entertainment', route: 'v4-ent-formats' },
  { module: 'wizard', route: 'v4-studio-wizard' },
  // La gestion des territoires et les pondérations sont parties dans Orion
  // Admin (8 octobre 2026) ; avec `territories`, PreCog reste ici.
  { module: 'territories', route: 'v4-precog' },
];

export function accueilDuCompte(): { name: string } {
  const { canOpen } = useSession();
  return { name: ACCUEILS.find((a) => canOpen(a.module))?.route ?? 'v4-portfolio' };
}
